// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"UserVerificationWithOnfido_titleContainer__1YSkA"};